import { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { useEntitlements } from './useEntitlements';

/**
 * Custom hook for managing the Pro upgrade modal
 * Shows the modal for non-Pro users
 */
export function useProUpgradeModal() {
  const { currentUser } = useAuth();
  const { hasPro, loading: entitlementsLoading } = useEntitlements();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkShouldShowModal = async () => {
      // Don't show modal if user is not signed in or entitlements are still loading
      if (!currentUser || entitlementsLoading) {
        setLoading(false);
        return;
      }

      // Don't show modal if user has Pro
      if (hasPro) {
        setLoading(false);
        return;
      }

      setLoading(false);
    };

    checkShouldShowModal();
  }, [currentUser, hasPro, entitlementsLoading]);

  const closeModal = () => {
    setShowModal(false);
  };

  return {
    showModal,
    closeModal,
    loading
  };
}